import { render, staticRenderFns } from "./HypervisorUnitIcon.vue?vue&type=template&id=2990fbee"
import script from "./HypervisorUnitIcon.vue?vue&type=script&lang=js"
export * from "./HypervisorUnitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports